import type { ConfigStore } from ".";

export const selectStandardBloodTestPackages = (state: ConfigStore) => {
  return state.config?.bloodTestPackages.filter((p) => !p.isUpsell) ?? [];
};

export const selectUpsellBloodTestPackages = (state: ConfigStore) => {
  return state.config?.bloodTestPackages.filter((p) => p.isUpsell) ?? [];
};
